import { render } from "./offered-jobs.vue?vue&type=template&id=27c34044"
import script from "./offered-jobs.vue?vue&type=script&lang=js"
export * from "./offered-jobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__